import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import "./assets/css/design.css";
import "./assets/css/photoEdit_1280-1389.css";
import "./assets/css/photoEdit_1390-1620.css";
import "./assets/css/reset.min.css";
import "./assets/css/photoEdit.css";
import "./assets/css/photoEdit_767.css";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);



